// extracted by mini-css-extract-plugin
module.exports = {"block":"_3761","label":"_11177","arrow":"_1706"};